var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarProcedureManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 6.00004H12.5C12.643 5.99882 12.7846 6.0283 12.9153 6.08648C13.0459 6.14465 13.1626 6.23018 13.2574 6.33728C13.3522 6.44439 13.4229 6.57057 13.4647 6.70733C13.5066 6.84409 13.5186 6.98823 13.5 7.13004L12.77 12.63C12.7383 12.8721 12.6191 13.0943 12.4349 13.2545C12.2506 13.4148 12.0142 13.5021 11.77 13.5H2.23001C1.98585 13.5021 1.74938 13.4148 1.56517 13.2545C1.38096 13.0943 1.26174 12.8721 1.23001 12.63L0.510012 7.13004C0.491529 6.98907 0.503318 6.84578 0.544591 6.70973C0.585864 6.57368 0.655673 6.448 0.749362 6.34106C0.84305 6.23412 0.958464 6.14839 1.08791 6.08959C1.21735 6.03078 1.35784 6.00025 1.50001 6.00004H2.50001",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.46 13.5L8.33 4H8.75C9.21413 4 9.65925 3.81563 9.98744 3.48744C10.3156 3.15925 10.5 2.71413 10.5 2.25C10.5 1.78587 10.3156 1.34075 9.98744 1.01256C9.65925 0.684374 9.21413 0.5 8.75 0.5H5.25C4.78587 0.5 4.34075 0.684374 4.01256 1.01256C3.68437 1.34075 3.5 1.78587 3.5 2.25C3.5 2.71413 3.68437 3.15925 4.01256 3.48744C4.34075 3.81563 4.78587 4 5.25 4H5.66L3.54 13.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarProcedureManagement);
export default __webpack_public_path__ + "static/media/sidebar-procedure-management.6abba74cfb52b80d2a5bbde424bf0993.svg";
export { ForwardRef as ReactComponent };